import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute, ViewChild, ElementRef, Renderer2
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef, MatSnackBar
} from '@angular/material';


@Component({
  selector: 'app-image-viewer-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'image-viewer-dialog.template.html'
})

export class ImageViewerDialogComponent implements OnInit {

  asset:any;

  constructor(public dialogRef: MatDialogRef<ImageViewerDialogComponent>,
              private renderer:Renderer2,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.asset = data;

  }

  public ngOnInit(): void {
  }

  public cancel() {
    this.dialogRef.close();
  }
}
